import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=bae8ed28&"
import script from "./TransactionList.vue?vue&type=script&lang=js&"
export * from "./TransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports